// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__OQpsI","copyright":"Footer_copyright__tIke_","legal":"Footer_legal__2cpGZ","socials":"Footer_socials__SIBUu"};